module.exports = __webpack_public_path__ + "static/media/team2.5940d3fa.png";